import LTable from './table.vue'

export default LTable;